import React from 'react';
import PropTypes from 'prop-types';
import { TableRow, TableCell, IconButton, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Delete } from '@mui/icons-material';
import { TextField } from '@totalsoft/rocket-ui';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import FormulaField from 'features/common/components/formula-field';
import { FormulaFieldContainer, FormulaFieldLabel } from 'components/common/Styles';

const EngineRuleListItemComponent = ({ containerDispatcher, item, index, validation, isReadOnly }) => {
  const { t } = useTranslation();

  const onPropertyChanged = (property, propertyValue) => {
    containerDispatcher({
      type: 'OnEngineRuleChanged',
      property,
      propertyValue,
      index
    });
  };

  const onDeleteRule = () => {
    containerDispatcher({
      type: 'OnEngineRuleDeleted',
      engineRuleId: item.engineRuleId,
      index
    });
  };

  return (
    <TableRow hover key={index}>
      <TableCell>
        <TextField
          isNumeric
          fullWidth
          decimalScale={0}
          value={item.number}
          onChange={event => onPropertyChanged('number', event)}
          disabled={isReadOnly}
          error={!isValid(validation.number)}
          helperText={getErrors(validation.number)}
        />
      </TableCell>
      <TableCell>
        <TextField
          fullWidth
          name='name'
          value={item.name || ''}
          onChange={event => onPropertyChanged('name', event)}
          disabled={isReadOnly}
          error={!isValid(validation.name)}
          helperText={getErrors(validation.name)}
        />
      </TableCell>
      <TableCell>
        <FormulaFieldContainer>
          <FormulaField value={item.expression} disabled={isReadOnly} onChange={value => onPropertyChanged('expression', value)} />
        </FormulaFieldContainer>
        <FormulaFieldLabel error={!isValid(validation.expression)}>{getErrors(validation.expression)}</FormulaFieldLabel>
      </TableCell>
      <TableCell align='right'>
        <Tooltip title={t('Tooltips.Delete')}>
          <IconButton color='primary' onClick={onDeleteRule} disabled={isReadOnly}>
            <Delete />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

EngineRuleListItemComponent.propTypes = {
  containerDispatcher: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  isReadOnly: PropTypes.bool,
  validation: PropTypes.object.isRequired
};

export default EngineRuleListItemComponent;
